<template>
  <svg
    v-if="shapes && shapes.length"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    aria-hidden="true"
    class="sidebar-icon"
  >
    <path
      v-for="(shape, index) in pathShapes"
      :key="'p-' + index"
      v-bind="shape.attrs"
    />
    <circle
      v-for="(shape, index) in circleShapes"
      :key="'c-' + index"
      v-bind="shape.attrs"
    />
    <rect
      v-for="(shape, index) in rectShapes"
      :key="'r-' + index"
      v-bind="shape.attrs"
    />
    <polygon
      v-for="(shape, index) in polygonShapes"
      :key="'g-' + index"
      v-bind="shape.attrs"
    />
  </svg>
</template>

<script>
import { SIDEBAR_ICONS } from "./paths";

export default {
  name: "SidebarIcon",

  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: [Number, String],
      default: 17,
    },
  },

  computed: {
    shapes() {
      return SIDEBAR_ICONS[this.name] || null;
    },

    pathShapes() {
      return (this.shapes || []).filter((s) => s.type === "path");
    },

    circleShapes() {
      return (this.shapes || []).filter((s) => s.type === "circle");
    },

    rectShapes() {
      return (this.shapes || []).filter((s) => s.type === "rect");
    },

    polygonShapes() {
      return (this.shapes || []).filter((s) => s.type === "polygon");
    },
  },
};
</script>

<style scoped>
.sidebar-icon {
  display: block;
  flex-shrink: 0;
}
</style>
